import ExcelJS from "exceljs";
import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../../usecases/object";
import AverageSalesTimePresenter from "./AverageSalesTimePresenter.js";
import Export from "../../../../components/Export/index.js";
import printChart from "../../../../PrintChart.js";
import { Progress } from "../../../../nq-component";
import DefaultState from "../../../sales-and-transactions/components/DefaultState.js";
import Select from "react-select";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import ProgressLoader from "../../../../components/ProgressLoader/index.js";
import DateRangeReport from "../../../../components/DateRangeReport/index.js";
import InitialPrompt from "../../../../components/InitialPrompt/index.js";
import PageHeader from "../../../../components/PageHeader/index.js";
import CustomSelect from "../../../../components/CustomSelect/index.js";
import { addDays, addHours, addMinutes, format, startOfDay } from "date-fns";

class AverageSalesTimePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AverageSalesTimePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
    );

    this.state = {
      objects: [],
      isShow: false,
      selectedDate: new Date().toISOString().split("T")[0],
      selectedStoreCode: "",
      averageSalesPerHour: [],
      storess: "",
      store: [],
      notFound: false,
    };
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) =>
      obj.store_code.replace("ANGELSPIZZA_", ""),
    );

    return [...new Set(storeCodes)]; // Remove duplicates
  }

  filterTransactions(transactions) {
    const selectedDate = new Date(this.state.selectedDate);
    selectedDate.setHours(5, 0, 0, 0);

    const endDate = new Date(selectedDate);
    endDate.setDate(endDate.getDate() + 1);
    endDate.setHours(4, 59, 59, 999);

    return transactions
      .filter((status) => status.status === "C")
      .filter((transaction) => {
        const transactionDate = new Date(transaction.tran_date);

        const selectedDateMatch =
          transactionDate >= selectedDate && transactionDate <= endDate;
        const storeCodeMatch = this.state.selectedStoreCode
          ? transaction.store_code.replace("ANGELSPIZZA_", "") ===
            this.state.selectedStoreCode
          : true;

        return true;
      });
  }

  // filterTransactions(transactions) {
  //   const selectedDate = new Date(this.state.selectedDate);
  //   selectedDate.setHours(0, 0, 0, 0);

  //   const startDate = addHours(startOfDay(selectedDate), 5);
  //   const endDate = addMinutes(addHours(addDays(startDate, 1), -1), 59);

  //   const formattedStartDate = format(startDate, "yyyy-MM-dd HH:mm:ss.SSS");
  //   const formattedEndDate = format(endDate, "yyyy-MM-dd HH:mm:ss.SSS");

  //   console.log("Selected Date Range: ", {
  //     $gte: formattedStartDate,
  //     $lte: formattedEndDate,
  //   });

  //   return transactions
  //     .filter((status) => status.status === "C")
  //     .filter((transaction) => {
  //       const transactionDate = new Date(transaction.tran_date);

  //       const transactionDateMatch =
  //         transactionDate >= startDate && transactionDate <= endDate;
  //       const storeCodeMatch = this.state.selectedStoreCode
  //         ? transaction.store_code.replace("ANGELSPIZZA_", "") ===
  //           this.state.selectedStoreCode
  //         : true;

  //       // return transactionDateMatch && storeCodeMatch;
  //       return true;
  //     });
  // }

  handleDateChange(event) {
    const selectedDate = event.target.value;
    const formattedDate = this.formatDate(selectedDate);
    this.setState({ selectedDate: event.target.value, isShow: true });
    // this.setState({ selectedDate });
    this.presenter.onChangeDate(formattedDate);
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  formatDate(dateString) {
    const date = new Date(dateString);

    // Start date (same day at 05:00:00.000)
    const startTime = new Date(date);
    startTime.setHours(5, 0, 0, 0);
    const formattedStartTime = this.formatDateToCustom(startTime);

    // End date (next day at 04:59:00.000)
    const endTime = new Date(date);
    endTime.setDate(endTime.getDate() + 1); // Move to the next day
    endTime.setHours(4, 59, 0, 0);
    const formattedEndTime = this.formatDateToCustom(endTime);

    return {
      tran_date: {
        $gte: formattedStartTime,
        $lte: formattedEndTime,
      },
    };
  }

  formatDateToCustom(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value }); // Update the state when store code changes
  }

  // calculateAverageSales(transactions) {
  //   const totalSales = new Array(24).fill(0); // Array for 23 hours (5 AM to 4 AM)
  //   const hourCounts = new Array(24).fill(0);

  //   transactions.forEach((transaction) => {
  //     const date = new Date(transaction.tran_date);
  //     const hour = date.getHours();

  //     // Adjust the index to start from 5 AM
  //     const index = hour < 5 ? hour + 19 : hour - 5; // Hours 0-4 become 19-22, hours 5-23 stay as 0-18

  //     const grossSales =
  //       parseFloat(transaction.total) +
  //       parseFloat(transaction.discount_amount) +
  //       parseFloat(transaction.total_tax);
  //     const sales = grossSales - parseFloat(transaction.discount_amount);

  //     totalSales[index] += sales;
  //     hourCounts[index]++;
  //   });

  //   // Calculate the average sales for each hour
  //   const averageSales = totalSales.map((total, index) => {
  //     return hourCounts[index] > 0 ? total / hourCounts[index] : 0;
  //   });

  //   return { averageSales };
  // }
  calculateAverageSales(transactions) {
    const totalSales = new Array(24).fill(0); // Array for 23 hours (5 AM to 4 AM)
    const transactionCounts = new Array(24).fill(0);

    transactions.forEach((transaction) => {
      const date = new Date(transaction.tran_date);
      const hour = date.getHours();

      // Adjust the index to start from 5 AM
      const index = hour < 5 ? hour + 19 : hour - 5; // Hours 0-4 become 19-22, hours 5-23 stay as 0-18

      const grossSales = parseFloat(transaction.total);
      const sales = grossSales - parseFloat(transaction.total_tax);

      totalSales[index] += sales;
      transactionCounts[index]++;
      // console.log(
      //   `Transaction at hour ${hour}: index ${index}, count ${transactionCounts[index]}`
      // );
    });

    // console.log("Transaction counts for each hour:", transactionCounts);

    // Calculate the average sales for each hour
    const averageSales = totalSales.map((total, index) => {
      return transactionCounts[index] > 0
        ? total / transactionCounts[index]
        : 0;
    });

    return { averageSales };
  }

  getChartData() {
    const filteredTransactions = this.filterTransactions(this.state.objects);
    // console.warn("TOTAL: ", filteredTransactions);
    const { averageSales } = this.calculateAverageSales(filteredTransactions);
    if (
      JSON.stringify(this.state.averageSalesPerHour) !==
      JSON.stringify(averageSales)
    ) {
      this.setState({ averageSalesPerHour: averageSales });
    }

    const labels = Array.from({ length: 24 }, (_, i) => {
      const hour = (5 + i) % 24;
      return `${hour}:00`;
    });

    const formattedAverageSales = averageSales.map((sales) => sales.toFixed(2));

    return {
      labels: labels, // 0 to 23, labeled as hours
      datasets: [
        {
          label: "Average Sales",
          data: formattedAverageSales,
          backgroundColor: "#006096",
          borderColor: "#006096",
          borderWidth: 1,
        },
      ],
    };
  }

  // getChartOptions() {
  //   return {
  //     scales: {
  //       y: {
  //         beginAtZero: true,
  //       },
  //     },
  //   };
  // }
  getChartOptions() {
    const filteredTransactions = this.filterTransactions(this.state.objects);
    const { averageSales } = this.calculateAverageSales(filteredTransactions);

    const labels = Array.from({ length: 24 }, (_, i) => {
      const hour = (5 + i) % 24;
      return `${hour}:00`;
    });

    const formattedAverageSales = averageSales.map((sales) =>
      parseFloat(sales.toFixed(2)),
    );

    return {
      chart: {
        type: "column",
      },
      title: {
        text: "Average Sales vs. Hour of Today",
      },
      xAxis: {
        categories: labels,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: "Average Sales (PHP)",
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>₱ {point.y:.2f}</b></td></tr>',
        footerFormat: "</table>",
        shared: true,
        useHTML: true,
      },
      series: [
        {
          name: "Average Sales",
          data: formattedAverageSales,
          color: "#006096",
        },
      ],
    };
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  getCollectionName() {
    return "transactions";
  }

  convertToCSV(objArray) {
    const array =
      typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
    let str =
      `${Object.keys(array[0])
        .map((value) => `"${value}"`)
        .join(",")}` + "\r\n";
    for (let i = 0; i < array.length; i++) {
      let line = "";
      for (let index in array[i]) {
        if (line !== "") line += ",";
        line += `"${array[i][index]}"`;
      }
      str += line + "\r\n";
    }
    return str;
  }

  exportToCSV = async () => {
    const { selectedStoreCode, averageSalesPerHour, range } = this.state;

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("Avg Sales per Hour");

    // ===== COLORS (ARGB) =====
    const TITLE_BLUE = "FF0076BA";
    const HEADER_GREEN = "FF83C14A";
    const LIGHT_GRAY = "FFF2F2F2";
    const BORDER = "FFCCCCCC";

    const borderStyle = {
      top: { style: "thin", color: { argb: BORDER } },
      left: { style: "thin", color: { argb: BORDER } },
      bottom: { style: "thin", color: { argb: BORDER } },
      right: { style: "thin", color: { argb: BORDER } },
    };

    // ===== TITLE =====
    ws.mergeCells("A1:B1");
    ws.getCell("A1").value = "Average Sales vs. Hour Of Today";
    ws.getCell("A1").font = {
      bold: true,
      size: 14,
      color: { argb: "FFFFFFFF" },
    };
    ws.getCell("A1").alignment = { horizontal: "center", vertical: "middle" };
    ws.getCell("A1").fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: TITLE_BLUE },
    };
    ws.getRow(1).height = 24;

    // ===== DATE RANGE (pretty) =====
    const prettyDateRange =
      range?.tran_date?.$gte && range?.tran_date?.$lte
        ? `${new Date(range.tran_date.$gte).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })} - ${new Date(range.tran_date.$lte).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}`
        : "No date selected";

    // ===== META =====
    ws.getCell("A2").value = "Brand";
    ws.getCell("B2").value = "Angels Pizza";

    ws.getCell("A3").value = "Store";
    ws.getCell("B3").value = selectedStoreCode || "All Stores";

    ws.getCell("A4").value = "Date Range";
    ws.getCell("B4").value = prettyDateRange;

    ["A2", "A3", "A4"].forEach((addr) => {
      ws.getCell(addr).font = { bold: true };
      ws.getCell(addr).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: LIGHT_GRAY },
      };
    });

    // ===== TABLE HEADER =====
    const headerRow = 6;
    ws.getRow(headerRow).values = ["Hour", "Average Sales"];
    ws.getRow(headerRow).font = { bold: true, color: { argb: "FFFFFFFF" } };
    ws.getRow(headerRow).alignment = {
      horizontal: "center",
      vertical: "middle",
    };
    ws.getRow(headerRow).height = 18;

    ws.getRow(headerRow).eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: HEADER_GREEN },
      };
      cell.border = borderStyle;
    });

    // ===== DATA ROWS =====
    let rowIndex = headerRow + 1;

    (averageSalesPerHour || []).forEach((sales, index) => {
      const hour = (5 + index) % 24; // your original rule
      const hourLabel = `${String(hour).padStart(2, "0")}:00`;

      ws.getRow(rowIndex).values = [hourLabel, Number(sales || 0)];
      ws.getCell(`B${rowIndex}`).numFmt = "#,##0.00";

      ws.getRow(rowIndex).eachCell((cell, col) => {
        cell.border = borderStyle;
        cell.alignment =
          col === 2
            ? { horizontal: "right", vertical: "middle" }
            : { horizontal: "left", vertical: "middle" };
      });

      rowIndex++;
    });

    // ===== COLUMN WIDTHS =====
    ws.getColumn(1).width = 14; // Hour
    ws.getColumn(2).width = 18; // Average Sales

    // ===== FREEZE + FILTER =====
    ws.views = [{ state: "frozen", ySplit: headerRow }];
    ws.autoFilter = {
      from: { row: headerRow, column: 1 },
      to: { row: headerRow, column: 2 },
    };

    // ===== DOWNLOAD (no file-saver) =====
    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "average-sales-hourly.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const range = this.state.range;
    const chartData = this.getChartData();
    const chartOptions = this.getChartOptions();
    const uniqueStoreCodes = this.getUniqueStoreCodes();
    const printId = "chart-container2";
    const formatSales = (sales) => {
      return sales.toLocaleString("en-US", {
        style: "currency",
        currency: "PHP",
      });
    };

    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <PageHeader
            title="Average Sales vs. Hour Of Today"
            subtitle="Analyze average sales performance by hour for today"
            icon="bi bi-clock-history"
          />
          <Export
            exportCsv={() => this.exportToCSV()}
            exportPdf={() => printChart(printId)}
          />
        </div>
        <div className="row mb-2">
          {/* <div className="col-sm-2">
            <input
              className="form-control"
              type="date"
              // value={this.state.selectedDate}
              onChange={this.handleDateChange}
            />
          </div> */}
          <div className="col" style={{ maxWidth: "max-content" }}>
            <DateRangeReport
              onChange={this.onChangeDate.bind(this)}
              field="tran_date"
            />
          </div>
          <div className="col-sm-4">
            <CustomSelect
              label="Store"
              options={[
                // { value: "AllStore", label: "All Store" },
                ...this.state.store.map((store) => ({
                  value: store.name,
                  label: store.name.replace(/_/g, " "),
                })),
              ]}
              onChange={(selected) => this.onChangeStore(selected.value)}
              isDisabled={!this.state.range}
              error={
                !this.state.range ? "Please select a date range first" : ""
              }
              icon="bi bi-shop"
              placeholder="Select Store"
              isClearable={true}
            />
          </div>
        </div>

        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />
        {this.state.objects && this.state.objects.length > 0 ? (
          <div ref={this.chartRef1} id="chart-container2">
            <div className="card">
              <HighchartsReact highcharts={Highcharts} options={chartOptions} />
            </div>
            <div className="print-only-content">
              <h2>Report Details</h2>
              <div className=" print-only-content">
                <div className="">
                  <h3>Brand: Angels Pizza</h3>
                  <h3>Store: {this.state.storess}</h3>
                  <h3>
                    Date:{" "}
                    {range?.tran_date?.$gte && range?.tran_date?.$lte
                      ? `${new Date(range.tran_date.$gte).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          },
                        )} - ${new Date(
                          range.tran_date.$lte,
                        ).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}`
                      : "No date selected"}
                  </h3>
                </div>
              </div>
              <div className="" style={{ fontSize: "20px" }}>
                <table className="table text-center">
                  <thead>
                    <tr className="d-flex">
                      <th>Month</th>
                      <th className="ms-5">Sales</th>{" "}
                    </tr>
                  </thead>
                  Í
                  <tbody>
                    {chartData.labels.map((label, index) => (
                      <tr className="d-flex" key={label}>
                        <td>{label}</td>
                        <td>
                          {formatSales(chartData.datasets[0].data[index])}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : this.state.notFound ? (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        ) : this.state.storess &&
          this.state?.selectedDate &&
          !this.state.notFound ? (
          <div className="text-center mt-5">
            <DefaultState />
          </div>
        ) : (
          // <div className="text-center align-items-center mt-4">
          //   <img
          //     src="./choosefirst.png"
          //     style={{ height: "200px", width: "200px" }}
          //   />
          //   <h4 className="mt-4 fw-semibold text-muted text-center">
          //     👋 To get started, please select a{" "}
          //     <span className="text-success">date range</span> and{" "}
          //     <span className="text-success">store</span> above.
          //   </h4>
          // </div>
          <InitialPrompt twoFilter={true} />
        )}
      </>
    );
  }
}

export default AverageSalesTimePage;
